
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_B2C_CLIENT_ID, 
    authority:
      process.env.REACT_APP_AZURE_B2C_AUTHORITY,
    knownAuthorities: [process.env.REACT_APP_AZURE_B2C_KNOWN_AUTHORITIES], 
    redirectUri: process.env.REACT_APP_CUSTOMER_CENTER_URL,
  },
 
  cache: {
    cacheLocation: process.env.REACT_APP_AZURE_B2C_CACHE_LOCATION,
    storeAuthStateInCookie: process.env.REACT_APP_AZURE_B2C_STORE_AUTH_STATE_IN_COOKIE,
  },
};
//Add this helper config
export const b2cPolicyConfig = {
  policyName: process.env.REACT_APP_AZURE_B2C_POLICY_NAME,
  scope: process.env.REACT_APP_AZURE_B2C_SCOPES,
};
export const getB2CLoginUrl = {
  returnUrl: process.env.REACT_APP_AZURE_B2C_LOGIN_URL
};